<template>
  <div class="modal fade" id="ticketDetailModal" ref="ticketDetailModal" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div id="ticketDetailModalHeader" class="modal-header p-2"
          :class="getPermission(1140).update
                  ? 'bg-gradient-warning'
                  : 'bg-gradient-danger'">
          <button type="button" class="btn-close" aria-label="Close" @click="closeTicketDetailModal"></button>
        </div>
        <refer-ticket-form v-if="getPermission(1140).update" :ticket="ticket" @referred="ticketReferred" />
        <div v-else>
          <div class="modal-body d-flex flex-column">
            <label for="CloseTicketDescription" class="form-label required">توضیحات</label>
            <div class="d-flex">
              <textarea class="form-control" rows="3" id="closeTicketDescription" name="closeTicketDescription"
                v-model.trim="description"></textarea>
              <chat-file-selector ref="closeTicketFileSelector" dynamicId="td" maxFileCount="5" :maxFileSize="50 * 1024 * 1024"
                validExtensions="rar,zip,doc,docx,pdf,xls,xlsx,ppt,pptx,txt,apng,png,avif,gif,jpg,jpeg,jfif,pjpeg,pjp,svg,webp"
                @filesUpdate="updateFiles" />
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button type="button" class="btn bg-gradient-danger" @click="closeTicket">بستن تیکت</button>
            <button type="button" class="btn bg-gradient-secondary" @click="closeTicketDetailModal">انصراف</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="card mb-4">
        <div class="card-body px-0">
          <div v-if="forCompany" class="table-responsive p-0">
            <table class="table table-striped table-styled table-sm">
              <thead>
                <tr>
                  <th scope="col">زمان ثبت</th>
                  <th scope="col">مجموعه</th>
                  <th scope="col">کاربر درخواست کننده</th>
                  <th scope="col">بخش هدف</th>
                  <th scope="col">سطح اهمیت</th>
                  <th scope="col">زمان صرف شده</th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
                <tr>
                  <td>
                    {{ $filters.toDateString(ticket.createDate) }}
                    <br />
                    {{ $filters.toTimeString(ticket.createTime) }}
                  </td>
                  <td>{{ ticket.createUser?.customerTitle ?? ticket.createUser?.companyTitle }}</td>
                  <td>{{ ticket.createUser?.firstName }} {{ ticket.createUser?.lastName }} - {{ ticket.createUser?.postTitle }}</td>
                  <td>{{ ticket.companySectionTitle }}</td>
                  <td>{{ importances[ticket.ticketImportanceEnum] }}</td>
                  <td>{{ $filters.minutesToTimeString(totalMinutesSpent) }}</td>
                </tr>
              </tbody>
            </table>
            <hr class="horizontal dark" />
          </div>
          <div>
            <ticket-detail-chat-box :ticket="ticket" @submited="formSubmit" @bookmark-toggle="bookmarkToggle" />
            <button class="btn bg-gray-400 float-start me-3 mb-0 mt-3" @click="$router.back()"
              :disabled="lockButtons">بازگشت</button>
            <button class="btn bg-gradient-warning float-start mb-0 mt-3"
              @click="openTicketDetailModal" data-bs-target="#ticketDetailModal" :disabled="lockButtons"
              v-if="
                getPermission(1140).update
                &
                (
                  !(ticket.lastCompanySection?.hasConfidentialConversations)
                  | getPermission(1050).view
                  | currentUserInfo.companySections.map(x => x.id).includes(ticket.lastCompanySection?.id)
                )">
              ارجاع تیکت
            </button>
            <button v-if="![4, 5, 6].includes(this.ticket.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum)
                          & (!getPermission(1140).insert)
                          & (getPermission(1130).update | !forCompany)
                          & (currentUserInfo.id == ticket?.createUser?.id)"
              class="btn bg-gradient-danger float-start mt-3 mb-0" type="button" @click="openTicketDetailModal" :disabled="lockButtons">
              بستن تیکت
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseService from "../../services/Base-service";
import TicketService from "@/services/Ticket/Ticket-service.js";
import TicketDetailForm from "@/views/Ticket/TicketDetailForm.vue";
import TicketDetailChatBox from "../components/Chat/TicketDetailChatBox.vue";
import ChatFileSelector from "../components/File/ChatFileSelector.vue";
import ReferTicketForm from "./ReferTicketForm.vue";
import { mapGetters } from "vuex";

export default {
  components: { TicketDetailForm, TicketDetailChatBox, ChatFileSelector, ReferTicketForm },
  data() {
    return {
      ticket: {},
      importances: ['پایین', 'متوسط', 'بالا'],
      forCompany: false,
      description: '',
      files: [],
      lockButtons: false,
      totalMinutesSpent: 0,
    };
  },
  computed: {
    ...mapGetters(['currentUserInfo', 'getPermission']),
  },
  methods: {
    getTicketById() {
      if (this.forCompany) {
        this.getTicketWithDetailsAndReferrals();
      }
      else {
        this.getTicketWithDetails();
      }
    },
    getTicketWithDetails() {
      TicketService.getTicketWithDetails(this.ticket.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.ticket = result.data;
          this.mapTicketDetails();
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      })
    },
    getTicketWithDetailsAndReferrals() {
      TicketService.getTicketWithDetailsAndReferrals(this.ticket.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.ticket = result.data;
          this.ticket.ticketDetails =
            [
              ...this.ticket.ticketDetails,
              ...this.ticket.referrals.map(x => ({ ...x, createUser: x.senderUser, message: x.senderComment, isReferral: true }))
            ];
            this.mapTicketDetails();
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      mapTicketDetails() {
        document.title = this.ticket.title;

        this.ticket.ticketDetails = this.ticket.ticketDetails.map(x =>
        ({
          ...x,
          createDate: x.createDate || this.ticket.createDate,
          createTime: x.createTime || this.ticket.createTime,
          sortProp: parseInt((x.createDate || this.ticket.createDate) + (x.createTime || this.ticket.createTime))
        }));

        let timeSpentList = this.ticket.ticketDetails.filter(td => td.timeSpent?.length > 0).map(td => (parseInt(td.timeSpent.slice(0, 2)) * 60) + parseInt(td.timeSpent.slice(3, 5)));
        this.totalMinutesSpent = timeSpentList.map(ts => ts).reduce((a,b) => a + b, 0);

        this.$store.dispatch('removeListFromNotificationsByTicketIds', [this.ticket.id]);
    },
    closeTicket() {
      if (!this.description) {
        this.$toast.error('لطفا توضیحات مربوطه را ثبت کنید');
        return;
      }

      this.lockButtons = true;

      let postFileAddrees = '/Ticket/CloseTicketByOwner';

      let ticketDetail = new FormData();
      ticketDetail.append('Message', this.description);
      ticketDetail.append('TicketId', this.ticket.id);

      for (var i = 0; i < this.files.length; i++) {
        ticketDetail.append("Files", this.files[i]);
      }

      BaseService.postFile(postFileAddrees, ticketDetail).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);
          this.description = '';
          this.$refs.closeTicketFileSelector.files = [];

          this.closeTicketDetailModal();
        } else {
          this.$toast.error(result.message);
        }

        this.lockButtons = false;
        this.getTicketById();

      }).catch(e => {
        console.log(e);
      });
    },
    updateFiles(files) {
      this.files = files;
    },
    goToReferTicketForm() {
      this.$router.push('/referTicket/' + this.ticket.id);
    },
    formSubmit() {
      this.getTicketById();
    },
    ticketReferred() {
      this.formSubmit();

      this.closeTicketDetailModal();
    },
    openTicketDetailModal() {
      this._modalInstance.show();
    },
    closeTicketDetailModal() {
      this._modalInstance.hide();
    },
    bookmarkToggle() {
      this.bookmarkChannel.postMessage({ ticketId: this.ticket.id });

      this.ticket.isBookmarked = !this.ticket.isBookmarked;
    }
  },
  created() {
    this.ticket.id = this.$route.params.ticketId;
    this.forCompany = this.$store.state.currentUserInfo.isCompanyUser;
    this.getTicketById();
  },
  mounted() {
    this._modalInstance = new bootstrap.Modal(this.$refs.ticketDetailModal);

    this.bookmarkChannel = new BroadcastChannel('bookmarkToggle')

    this.bookmarkChannel.onmessage = ({ data }) => {
      const { ticketId } = data;
      
      if (this.ticket.id == ticketId)
        this.ticket.isBookmarked = !this.ticket.isBookmarked;
    }
  },
  beforeUnmount() {
    this.bookmarkChannel.close();
    
    document.title = 'سامانه جامع تیکتینگ';
  }
}
</script>